import { ChangeDetectorRef, Component, inject, Input, OnInit, signal, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { from, map, Observable, share, Subscription, timer } from 'rxjs';
import { HeaderComponent } from '../../commons/components/header/header.component';
import { AppModule } from '../../app-module';
import { NotificacionesService } from '../notificacion/General/notificaciones.service';
import { IdleTimeoutService } from '../../commons/services/timeout.service';
import { DialogServiceRenuevaSession } from '../../commons/services/dialog-Renueva.service';
import { AuthService } from '../../commons/services/auth.service';


@Component({
  selector: 'oaj-itx-principal',
  /*   imports: [RouterOutlet, RouterLink,DatePipe], */ //V1
  imports: [AppModule, RouterOutlet, HeaderComponent],
  templateUrl: 'principal.component.html',
  styleUrl: 'principal.component.css',
})
export class Principal implements OnInit, OnDestroy {

  @Input() ID = 0;
  fechaDeHoy = new Date();
  hora = new Date();
  subscription: Subscription | undefined;
  totalesSubscription?: Subscription;
  refreshTotalesSubscription?: Subscription;
  totalesNotificaciones = {
    notificadas: 0,
    noNotificadas: 0,
  };
  bPermisoAdmin = false;
  bSuperAdmin = false;
  bOrganoSupervisado = false;

  public _counter = 0;
  public _status = "Initialized.";
  public _renovo = false;
  private _timer!: Observable<number>;
  private _timerSubscription?: Subscription;
  private _idleTimerSubscription?: Subscription;

  protected readonly title = signal('interconexion-app');
  private router = inject(Router);
  private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private notificacionesService: NotificacionesService = inject(NotificacionesService);
  private idleTimeoutSvc: IdleTimeoutService = inject(IdleTimeoutService);
  private dialogSvc: DialogServiceRenuevaSession = inject(DialogServiceRenuevaSession);
  private changeRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private authService: AuthService = inject(AuthService);

  ngOnInit(): void {

    this.bPermisoAdmin = this.authService.getbPermisoAdmin();
    this.bSuperAdmin = this.authService.getbSuperAdmin();
    this.bOrganoSupervisado = this.authService.getEsOrganoSupervisado();
    this.reset();
    this.sessionTimeout();

    this.router.navigate(['/home']);
    this.subscription = timer(0, 1000)
      .pipe(
        map(() => new Date()),
        share()
      )
      .subscribe(time => {
        this.hora = time;
        this.changeDetectorRef.detectChanges();
      });
    this.subscribeToNotificationTotals();
    this.refreshTotalesSubscription = timer(0, 600000).subscribe(() => {
      this.loadNotificationTotals();
    });



  }



  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.totalesSubscription) {
      this.totalesSubscription.unsubscribe();
    }
    if (this.refreshTotalesSubscription) {
      this.refreshTotalesSubscription.unsubscribe();
    }
    if (this._timerSubscription) {
      this._timerSubscription.unsubscribe();
    }
    if (this._idleTimerSubscription) {
      this._idleTimerSubscription.unsubscribe();
    }
  }

  /**
   * Selecciona un ítem de interconexión y navega a su vista detallada.
   * @param Id 
   */
  SelectItx(Id: number) {
    this.ID = Id;
    this.router.navigate([`itx/${this.ID}`]);
  }

  /**
   * Función para reiniciar la vista principal, se establece el ID en 0 para mostrar la vista principal sin ningún detalle seleccionado
    * @returns
   */
  Inicio() {
    this.ID = 0;
  }

  /**
   * Obtiene el total de notificaciones
   * @returns
   */
  get totalNotificaciones(): number {
    return (
      (this.totalesNotificaciones?.notificadas || 0) +
      (this.totalesNotificaciones?.noNotificadas || 0)
    );
  }

  /**
   * Carga los totales de notificaciones para el OIJ seleccionado, se obtiene el ID del OIJ seleccionado utilizando el servicio de notificaciones, si no se encuentra un OIJ seleccionado se muestra una advertencia en la consola y se retorna, de lo contrario se llama al método actualizarTotales del servicio de notificaciones para obtener los totales de notificaciones, si la consulta es exitosa se asignan los totales a la propiedad totalesNotificaciones y se detectan los cambios en la vista, si ocurre un error al obtener los totales se muestra un mensaje de error en la consola
   * @returns 
   */
  private loadNotificationTotals(): void {
    const oijId = this.notificacionesService.getOijIdSeleccionado();
    if (oijId === null) {
      console.warn('No se encontro un OIJ seleccionado en sesion.');
      return;
    }

    this.notificacionesService.actualizarTotales(oijId).subscribe({
      next: (totales) => {
        this.totalesNotificaciones = {
          notificadas: totales.totalNotificadas ?? 0,
          noNotificadas: totales.totalNoNotificadas ?? 0,
        };
        this.changeDetectorRef.detectChanges();
      },
      error: (error) => {
        console.error('Error al obtener los totales de notificaciones', error);
      },
    });
  }

  /**
   * Función para suscribirse a los cambios en los totales de notificaciones, se asigna la suscripción a la propiedad totalesSubscription para poder manejar su ciclo de vida, se verifica si los totales recibidos son válidos, si no son válidos se retorna, de lo contrario se asignan los totales a la propiedad totalesNotificaciones y se detectan los cambios en la vista
   * @returns 
   */
  private subscribeToNotificationTotals(): void {
    this.totalesSubscription = this.notificacionesService.totales$.subscribe(
      (totales) => {
        if (!totales) {
          return;
        }
        this.totalesNotificaciones = {
          notificadas: totales.totalNotificadas ?? 0,
          noNotificadas: totales.totalNoNotificadas ?? 0,
        };
        this.changeDetectorRef.detectChanges();
      }
    );
  }

  /**
   * Función para manejar el tiempo de inactividad del usuario, se inicia un contador para medir el tiempo de inactividad, se suscribe al evento timeoutExpired del servicio de IdleTimeoutService para detectar cuando el tiempo de inactividad ha expirado, cuando se detecta que el tiempo de inactividad ha expirado se verifica si la sesión del usuario sigue siendo válida utilizando el servicio de autenticación, si la sesión no es válida se llama al método startLogout para cerrar la sesión del usuario, si la sesión es válida se muestra un mensaje de confirmación para renovar la sesión utilizando el servicio de DialogServiceRenuevaSession, si el usuario confirma que desea renovar la sesión se reinicia el temporizador de inactividad y se actualiza el estado, si el usuario no confirma que desea renovar la sesión o si ocurre un error al mostrar el mensaje de confirmación se llama al método startLogout para cerrar la sesión del usuario
   * @returns
   */
  sessionTimeout() {
    this.startCounter();
    this._idleTimerSubscription = this.idleTimeoutSvc.timeoutExpired.subscribe(() => {
      //Validar que el usuario siga activo, para mostrar el modal de renovación de sesión
      const isSessionActive = this.authService.getValidSessionCurrentUser();
      if (!isSessionActive) {
        return this.startLogout();
      }
      const modalPromise = this.dialogSvc.open('¡Tu sesión expirará en 5 minutos!', '¿Quieres renovar la sesión?', true, 'Sí', 'No');
      const newObservable = from(modalPromise);
      newObservable.subscribe(
        (resp) => {
          if (resp === true) {
            this._status = 'La sesión se renovó.';
            this.idleTimeoutSvc.resetTimer();
            this.startCounter();
            this.changeRef.markForCheck();
          } else {
            this._status = 'La sesión no se renovó.';
            this.changeRef.markForCheck();
            this.startLogout();
          }
        },
        () => {
          this._status = 'La sesión no se renovó.';
          this.changeRef.markForCheck();
          this.startLogout();
        }
      );
    });
  }

  /**
   * Función para reiniciar el temporizador de inactividad, se llama al método resetTimer del servicio de IdleTimeoutService para reiniciar el temporizador, se establece el estado en "Initialized." y se inicia el contador de inactividad
   * @returns
   */
  public reset() {
    this.startCounter();
    this._status = 'Initialized.';
    this.idleTimeoutSvc.resetTimer();
  }

  /**-
   * Función para cerrar la sesión del usuario, se llama a la función logout del servicio de autenticación para eliminar la información de autenticación del usuario y redirigirlo a la página de login
    * @returns
   */
  public startLogout() {
    this._idleTimerSubscription?.unsubscribe();
    this.idleTimeoutSvc.startLogout(this._counter);
  }

  /**
   * Función para iniciar el contador de inactividad, se verifica si ya existe una suscripción al temporizador, si existe se desuscribe para evitar múltiples suscripciones, se establece el contador en 0, se crea un nuevo observable utilizando la función timer que emite un valor cada segundo, se asigna la suscripción al temporizador a la propiedad _timerSubscription para poder manejar su ciclo de vida, cada vez que el temporizador emite un valor se incrementa el contador y se detectan los cambios en la vista
   */
  public startCounter() {
    if (this._timerSubscription) {
      this._timerSubscription.unsubscribe();
    }

    this._counter = 0;
    this._timer = timer(1000, 1000);
    this._timerSubscription = this._timer.subscribe(() => {
      this._counter++;
    });
  }

}
